import { ConfigurationFactory } from '@/app/subscription-ui/configuration.factory';
import { SubscriptionController } from '@/app/subscription-ui/subscription.controller';
import { App } from 'vue';
import { SubscriptionResource } from '../../../../modules/resource/subscription/subscription.resource';

export class SubscriptionControllerPlugin {

    constructor(private configurationFactory: ConfigurationFactory) {
    }

    public install(app: App, options?: []): void {
        app.provide('controller', new SubscriptionController(
            SubscriptionResource.getInstance(this.configurationFactory.getSubscriptionConfiguration()),
            this.configurationFactory.getApplicationData(),
        ));
    }

}
